import { useCms } from '~/components/hooks/useCms';
import useCurrentUserRoles from '~/components/hooks/useCurrentUserRoles';
import { CONFIGURATION_FEATURES_NAMES } from '~/Types';
import { isFeatureEnabled } from '~/Utils';

/**
 * Whether the current user may act on another user's outgoing email identity — compose as them, and
 * read the personal signature such an email would carry.
 *
 * Mirrors the server's `can_send_as_other_adjuster`: with ORG_HIERARCHY_WORKFLOWS on, a unit leader
 * or an org-level supervisor; with it off, an org-level supervisor. *Which* of those users are
 * reachable is a separate server-side decision (`restrict_send_as_to_managed_users`), so this only
 * decides whether the surface is offered at all — every route still enforces the scope itself.
 */
const useCanSendAsOtherAdjuster = (): boolean => {
  const { userOrganization } = useCms();
  const { isUserManager, isUserSupervisor } = useCurrentUserRoles();

  return isFeatureEnabled(userOrganization, CONFIGURATION_FEATURES_NAMES.ORG_HIERARCHY_WORKFLOWS)
    ? Boolean(isUserManager) || Boolean(isUserSupervisor)
    : Boolean(isUserSupervisor);
};

export default useCanSendAsOtherAdjuster;
